import {
  FOC_TOUR_LABEL_PLN_SITL,
  focFeedbackPopoverHtml,
} from '../focTourFeedback';
import { FOC_PLN_SITL_TOUR_HREF as HREF } from '../focTourHrefs';
import {
  FOC_REQUIRED_DISPOSITION,
  focPlnTourPopoverHtml,
  requirement,
  type FocPlnTourStepDef,
} from './focPlnTourTypes';

export const FOC_PLN_SITL_TOUR_PARAM = 'focPlnSitlTour';
export const FOC_PLN_SITL_TOUR_HREF = HREF;
export { focPlnTourPopoverHtml };

export const FOC_PLN_SITL_TOUR_STEPS: FocPlnTourStepDef[] = [
  {
    id: 'sectionIntro',
    tour: 'sitl-cop-workspace',
    title: FOC_TOUR_LABEL_PLN_SITL,
    description:
      'The Situation Unit workspace supports situation status, incident map/COP development, situation reporting, projections, map-backed briefings, approved layers, displays, and coordination with Command, Operations, Planning, and the Hub—including dedicated SITL COP functions described in Section 5.',
  },
  requirement({
    id: 'pln002',
    requirementId: 'FOC-PLN-002',
    name: 'Situation Unit Workspace',
    disposition: FOC_REQUIRED_DISPOSITION,
    tour: 'sitl-cop-workspace',
    description:
      'PRATUS provides a Situation Unit workspace supporting situation status, incident map/COP development, situation reporting, incident projections, map-backed briefings, approved data layers, incident displays, and coordination with Command, Operations, Planning, and the Hub.',
    bullets: [
      'FOC-PLN-002a — SITL Current Situation and Briefing Products: consolidates current status, significant events, metrics, operational-area status, weather/tides, hazards, resources/forces, facilities, map products, data currency, and approved narratives for command and Planning P briefings.',
      'FOC-PLN-002b — Situation Update Intake and Validation: authorized users submit updates; SITL can review, accept, correct, reject, or supersede; identify source and as-of time; publish approved information to COP, SITREP, displays, or other products.',
      'FOC-PLN-002c — SITREP Contribution: Situation Unit data can populate SITREP drafts without duplicate entry; SITL controls what is proposed and can flag stale, disputed, or unverified information.',
      'FOC-PLN-002d — Operational Period Rollover: preserves the prior situation record and creates the next period’s working context without silently replacing prior published maps, displays, reports, or metrics.',
    ],
  }),
  {
    id: 'focFeedback',
    title: 'FOC Feedback Notes',
    description: focFeedbackPopoverHtml(FOC_TOUR_LABEL_PLN_SITL),
  },
];
